import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  SetAuthenticatorSecretDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_USERS } from "../../domain";

import { usersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CONFIRM_AUTHENTICATOR = "CONFIRM_AUTHENTICATOR";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

const confirmAuthenticator = async (
  param: SetAuthenticatorSecretDto,
): Promise<void> => {
  const response = await usersApi.usersControllerSetMfaAuthenticatorSecret(param);

  return response.data;
};

export const useConfirmAuthenticator = (
  user: UserProfileDto | null,
): {
  confirmAuthenticator: (param: SetAuthenticatorSecretDto) => void;
  confirmAuthenticatorEnabled: boolean;
  confirmAuthenticatorError: Error | null;
  isSuccessConfirmAuthenticator: boolean;
  isPendingConfirmAuthenticator: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending, error } = useMutation({
    mutationKey: [DOMAIN_USERS, ACTION_CONFIRM_AUTHENTICATOR],
    mutationFn: enabled ? confirmAuthenticator : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_USERS] });
    },
  });

  return {
    confirmAuthenticator: mutate,
    confirmAuthenticatorEnabled: enabled,
    confirmAuthenticatorError: error,
    isSuccessConfirmAuthenticator: isSuccess,
    isPendingConfirmAuthenticator: isPending,
  };
};
